<template>
  <div>
    <el-dialog
      :visible="visible"
      title="修改密码"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
    >
   <div class="tip">您好，检测到您为首次登录系统/密码被重置，为了您的账户安全，请重新设置密码。</div>
      <div class="text item changepass_content">
         
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <!-- <el-form-item label="当前密码" prop="oldPassword">
            <el-input
              size="small"
              type="password"
              v-model="ruleForm.oldPassword"
              placeholder="请输入原密码"
              clearable
            ></el-input>
          </el-form-item> -->
          <el-form-item label="更改密码" prop="pass">
            <el-input
              size="small"
              type="password"
              v-model="ruleForm.newPassword"
              placeholder="请输入新密码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              size="small"
              type="password"
              v-model="ruleForm.checkPass"
              placeholder="请再次输入新密码"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item class="textcenter">
                <el-button size="small" type="primary" @click="submitFrom">确定</el-button>
              </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="btnLoading" type="primary" size="mini" @click="submitFrom">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {encodeKey} from '@/utils'
import request from '@/utils/request'
import {Storage} from "@/utils/storage"
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        newPassword: '',
        checkPass: ''
      },
      rules: {
        newPassword: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }]
      },
      btnLoading: false,
    }
  },
  methods: {
    submitFrom() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          const submitFormData = {};
          submitFormData['pazjofxkyvyoosot'] = encodeKey(this.ruleForm.newPassword)
          request
            .post('/mdm/mdmUserController/resetMyselfPassword', {
              ...submitFormData
            })
            .then((res) => {
              this.btnLoading = false
              if (res.success) {
                this.$emit('closeModal')
                this.$message.success('修改成功')
                Storage.l.set('resetPassword', '')
              }
            })
            .catch((e) => {
              this.btnLoading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tip{
  line-height: 30px;
  padding: 20px;
}
</style>
